/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

export const NavigationFonts = (): React.JSX.Element => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;

	return (
		<>
			<link rel="preconnect" href={epicComponentDomain} />
			<link rel="stylesheet" href={epicComponentDomain + "/styles/navigation.css"} />
		</>
	);
};
